import type { QueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { patchTicketCreate } from "@sd/lib/patchTicketCreate";
import { serviceDeskFormilyTicketGridQueryKey } from "@sd/services/APIs";

/** PATCH `/service_desk/ticket_create/{id}/` with `is_vip` boolean. */
export async function putTicketIsVip(
  queryClient: QueryClient,
  ticketId: string,
  isVip: boolean
): Promise<boolean> {
  try {
    const ok = await patchTicketCreate(queryClient, ticketId, {
      is_vip: isVip,
    });
    if (!ok) {
      toast.error("Failed to update VIP status");
      return false;
    }

    await queryClient.invalidateQueries({
      queryKey: serviceDeskFormilyTicketGridQueryKey,
    });

    return true;
  } catch {
    toast.error("Failed to update VIP status");
    return false;
  }
}
